// extracted by mini-css-extract-plugin
export var phone = "_1e-0";
export var phoneDragging = "_1e-1";